import { combineReducers } from 'redux';

import auth from './auth/reducer';
import { metronic } from '../../_metronic';

export default combineReducers({
    auth,
    i18n: metronic.i18n.reducer,
    builder: metronic.builder.reducer
});